export default __webpack_public_path__ + "static/imgHome3-4e239a6c6a01506a090791d86a240a6b.png";